import { render, staticRenderFns } from "./FileExpedientView.vue?vue&type=template&id=3d88b324&"
import script from "./FileExpedientView.vue?vue&type=script&lang=js&"
export * from "./FileExpedientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d88b324')) {
      api.createRecord('3d88b324', component.options)
    } else {
      api.reload('3d88b324', component.options)
    }
    module.hot.accept("./FileExpedientView.vue?vue&type=template&id=3d88b324&", function () {
      api.rerender('3d88b324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/FileExpedientView.vue"
export default component.exports